$(document).ready(function(){

  
  if(localStorage.getItem('firstCompareElementHandle') == null ){
    localStorage.setItem('firstCompareElementHandle', "empty1")
  }
  if(localStorage.getItem('secondCompareElementHandle') == null){
    localStorage.setItem('secondCompareElementHandle', "empty2")
  }
  if(localStorage.getItem('thirdCompareElementHandle') == null){
    localStorage.setItem('thirdCompareElementHandle', "empty3")
  }



  jQuery('#delete_elements').click(function(){
    var contador = 0;
    document.getElementById('counter').textContent = contador + " / 3"
    $('#compare_link').attr('onclick', "#");
  });

  jQuery('.add-to-compare-btn').click(function(e){
    console.log(e.target)
    e.preventDefault();
    jQuery('.compareBox-header').fadeIn('slow');
    if(jQuery('.compareBox-header').hasClass('active')){
    }else{
      jQuery('.compareBox-header').trigger('click');
    }
    if(e.target.tagName == "IMG"){
    console.log("img clicked")
    var handle = e.target.parentElement.getAttribute('handle')
    var img = e.target.parentElement.getAttribute('img')
    var title = e.target.parentElement.getAttribute('title')
    console.log(handle)
    console.log(img)
    console.log(title)
    }
    if(e.target.tagName == "BUTTON"){
    console.log("button clicked")
    var handle = e.target.getAttribute('handle')
    var img = e.target.getAttribute('img')
    var title = e.target.getAttribute('title')
    console.log(handle)
    console.log(img)
    console.log(title)
    
    }


    if(localStorage.getItem('firstCompareElementHandle') ==  "empty1") {
      localStorage.setItem('firstCompareElementHandle', handle)
      localStorage.setItem('firstCompareElementImg', img)
      localStorage.setItem('firstCompareElementTitle', title)
      var firstCompareHandle = localStorage.getItem('firstCompareElementHandle');
      var firstCompareImg = localStorage.getItem('firstCompareElementImg');
      var firstCompareTitle = localStorage.getItem('firstCompareElementTitle');
      console.log(firstCompareHandle)
      if(document.querySelector('#first_compare a') == null){
        var firstItem = document.getElementById('first_compare');
        let html1 = `<a class="gb-icon-close" onclick=""></a>
<a href="" class="gb-compare-item-content">
<div class="img-container"><img src="${firstCompareImg}"></div>
<p class="description-text">${firstCompareTitle}</p>
</a>` 
        jQuery('#first_compare').html(html1)
      }
      console.log('/pages/comparar-producto?ref='+firstCompareHandle+'')
      var contador = 1;
      document.getElementById('counter').textContent = contador + " / 3"
    }else{
      if(localStorage.getItem('secondCompareElementHandle') == "empty2") {

        localStorage.setItem('secondCompareElementHandle', handle)
        localStorage.setItem('secondCompareElementImg', img)
        localStorage.setItem('secondCompareElementTitle', title)
        var secondCompareHandle = localStorage.getItem('secondCompareElementHandle');
        var secondCompareImg = localStorage.getItem('secondCompareElementImg');
        var secondCompareTitle = localStorage.getItem('secondCompareElementTitle');
        var firstCompareHandle = localStorage.getItem('firstCompareElementHandle')
        console.log(secondCompareHandle)
        if(document.querySelector('#second_compare a') == null){
          var secondItem = document.getElementById('second_compare');
          let html2 = `<a class="gb-icon-close" onclick=""></a>
                        <a href="" class="gb-compare-item-content">
                        <div class="img-container"><img src="${secondCompareImg}"></div>
                        <p class="description-text">${secondCompareTitle}</p>
                        </a>` 
          jQuery('#second_compare').html(html2)
        }
        var contador = 2;
        document.getElementById('counter').textContent = contador + " / 3"
        setTimeout(function(){
          var middle = confirm("Desea visitar la página de comparación? Puede añadir 1 producto más.")
          if(middle == true){
            //IR A LA PAGE
            var goTo2 = '/pages/comparar-producto?ref='+firstCompareHandle+'&handle='+secondCompareHandle+''
            window.location = goTo2;
          }
        }, 1000)
        var pageMiddle = '/pages/comparar-producto?ref='+firstCompareHandle+'&handle='+secondCompareHandle+''
        console.log(pageMiddle)
        $('#compare_link').attr('onclick', 'location.href="'+pageMiddle+'"')
      }else{
        if(localStorage.getItem('thirdCompareElementHandle') == "empty3") {
          localStorage.setItem('thirdCompareElementHandle', handle)
          localStorage.setItem('thirdCompareElementImg', img)
          localStorage.setItem('thirdCompareElementTitle', title)
          var thirdCompareHandle = localStorage.getItem('thirdCompareElementHandle');
          var thirdCompareImg = localStorage.getItem('thirdCompareElementImg');
          var thirdCompareTitle = localStorage.getItem('thirdCompareElementTitle');
          var secondCompareHandle = localStorage.getItem('secondCompareElementHandle');
          var firstCompareHandle = localStorage.getItem('firstCompareElementHandle');
          console.log(thirdCompareHandle)
          if(document.querySelector('#third_compare a') == null){
            var thirdItem = document.getElementById('third_compare');
            let html3 = `<a class="gb-icon-close" onclick=""></a>
                        <a href="" class="gb-compare-item-content">
                        <div class="img-container"><img src="${thirdCompareImg}"></div>
                        <p class="description-text">${thirdCompareTitle}</p>
                        </a>` 
            jQuery('#third_compare').html(html3)
          }
          var contador = 3;
          document.getElementById('counter').textContent = contador + " / 3"
          setTimeout(function(){
            var lastComparision = confirm("Desea visitar la página de comparación?.")
            if(lastComparision == true){

              //IR A LA PAGE
              var goTo = '/pages/comparar-producto?ref='+firstCompareHandle+'&handle='+secondCompareHandle+'&handle='+thirdCompareHandle+''
              console.log(goTo)
              window.location = goTo;
            }
          }, 1000)
          
          var pageComplete = '/pages/comparar-producto?ref='+firstCompareHandle+'&handle='+secondCompareHandle+'&handle='+thirdCompareHandle+''
          console.log(pageComplete)
          $('#compare_link').attr('onclick', 'location.href="'+pageComplete+'"')
        }
      }
    }
    function goToPageCompare(){
      window.location = '/pages/comparar-producto?ref='+firstCompareHandle+'&handle='+secondCompareHandle+'&handle='+thirdCompareHandle+''
    }

    return false;
  });



  
  
  var coll = document.getElementsByClassName("compareBox-header");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var arrow = document.getElementById('arrow')
      if (content.style.display === "block") {
        content.style.display = "none";

        arrow.style.transform = "rotate(0)";
        arrow.style.top = "-5px";
      } else {
        content.style.display = "block";
        arrow.style.transform = "rotate(-180deg)";
        arrow.style.top = "-15px";
      }
    });
  }

});

